import { computed, Directive, input } from '@angular/core';
import { Typography } from '@nusign/picflow-backend-types';

interface CombinedTypography {
  text_alignment?: string;
  font_color?: null | string;
  font_family?: null | string;
  text_transform?: null | string;
  font_weight?: null | string;
  font_style?: null | string;
  letter_spacing?: null | number;
}

@Directive({
  selector: '[appApplyTypographyStyles]',
  host: {
    '[style.color]': 'typography().font_color',
    '[style.font-weight]': 'typography().font_weight',
    '[style.font-family]': 'typography().font_family',
    '[style.font-style]': 'typography().font_style',
    '[style.letter-spacing]': 'typography().letter_spacing + "em"',
    '[style.text-align]': 'typography().text_alignment',
    '[style.text-transform]': 'typography().text_transform',
  },
})
export class ApplyTypographyStylesDirective {
  appApplyTypographyStyles = input<CombinedTypography | CombinedTypography[]>();

  typography = computed(() => {
    const t = this.appApplyTypographyStyles();
    const typography = (Array.isArray(t) ? t : [t]).filter(Boolean);
    return <Typography>{
      font_color: typography.find(t => t.font_color)?.font_color,
      font_weight: typography.find(t => t['font_weight'])?.['font_weight'],
      font_family: typography.find(t => t.font_family)?.font_family,
      font_style: typography.find(t => t['font_style'])?.['font_style'] || 'none',
      letter_spacing: typography.find(t => t['letter_spacing'])?.['letter_spacing'] || '0',
      text_alignment: typography.find(t => t['text_alignment'])?.['text_alignment'] || 'left',
      text_transform: typography.find(t => t['text_transform'])?.['text_transform'] || 'none',
    };
  });
}
